import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    VStack,
    HStack,
    Input,
    Text,
    Box,
    Button,
    Flex,
    Radio,
    Checkbox,
} from '@chakra-ui/react';
import { AddIcon, DeleteIcon } from "@chakra-ui/icons";
import { useFormik } from "formik";
import * as Yup from 'yup'; // Add Yup for validation
import { GrubFormButton } from '../../../components';
import Colors from '../../../assets/colors/Colors';
import * as Constants from "../../../constants/Constants";
import { twofix } from "../../../helpers/calculation";
import { checkGiftCardNumber, postOrder, getUserCardDetails } from "../services/GiftCardServices";
import { deleteUserCardDetail } from "../../../modules/checkout/services/PaymentDetailsServices";
import { useHistory } from 'react-router-dom';
import { currentItem, removeCurrentItem } from "../../../actions/current_item";
import {
    orderCalculation,
    completeOrder,
    orderInstruction,
  } from "../../../actions/order_actions";
  import { insertItem, addExtraItem } from "../../../actions/order_items";
  import { updateOrdertype } from "../../../actions/delivery_pickup_action";
  import {
    addUserCardDetails,
    removeUserCardDetails,
  } from "../../../actions/card_Details_action";
  import {
    orderUser,
    userLogout,
    userLogin,
    addPaymentCardId,
    removeOrderUser,
  } from "../../../actions/user_actions";
  import { removeLocations } from "../../../actions/location_action";
  import { clearItems } from "../../../actions/order_items";
  import { removeDeliveryPickupDetails } from "../../../actions/delivery_pickup_action";
  import { removeFeaturedProducts, removeProducts } from "../../../actions/menu_items";
  import GrubToastMessage from "../../../components/alert/GrubToastMessage";
//   import SignIn from "../../modules/auth/screens/SignIn";
import AuthLayout from "../../../modules/auth/screens/AuthLayout"; 
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';
import moment from 'moment';
import {
    formatCreditCardNumber,
    formatCVC,
    formatExpirationDate,
  } from "../../../helpers/utils/CardUtils";
import BoxForPaymentMethode from "../../../modules/checkout/components/BoxForPaymentMethode";
import GrubTitleText from "../../../components/title/GrubTitleText";
import VisaLogo from "../../../assets/images/VisaLogo.svg";
import MasterCard from "../../../assets/images/masterCard.png";
import AmericanEx from "../../../assets/images/AmericaExLogo.svg";
import DiscoverLogo from "../../../assets/images/Discoverlogo.svg";
import DinersClub from "../../../assets/images/dinersClub.png";
import JCBLogo from "../../../assets/images/jcb.png";
import UnionPayLogo from "../../../assets/images/unionPay.png";
import defaultIcon from "../../../assets/images/defaultCard.png";
import store from "../../../store/store";
import { GrubProgress, GrubInput, GrubDialogAlert, GrubErrorMessage } from "../../../components/index";
import HomeText from "../../../modules/home/components/HomeText";
import {GrubErrorHook, GrubPopupErrorHook} from "../../../hooks/index";
import { isValidInput, isValidObject } from "../../../helpers/utils/Utils";
import { BlockUI } from "primereact/blockui";
import { ProgressSpinner } from "primereact/progressspinner";

const GiftCardModal = (props) => {
    // State management
    // const { error } = GrubErrorHook();
    const { error } = GrubPopupErrorHook();
    const  dialogError  = GrubPopupErrorHook();
    const [currentStep, setCurrentStep] = useState(1);
    const [customAmount, setCustomAmount] = useState('');
    const [selectedAmount, setSelectedAmount] = useState(null);
    const [recipientEmail, setRecipientEmail] = useState('');
    const [recipientPhone, setRecipientPhone] = useState('');
    const [customMessage, setCustomMessage] = useState('');
    const [giftCardCode, setGiftCardCode] = useState('');
    const [maskedGiftCardCode, setMaskedGiftCardCode] = useState('');
    const [errors, setErrors] = useState({
        number: '',
        email: '',
        sms: '',
        message: '',
    });
    const { addToast } = GrubToastMessage();
    const [isSignInModalOpen, setSignInModalOpen] = useState(false);
    // const [cardNumber, setCardNumber] = useState('');
    // const [validThru, setValidThru] = useState('');
    // const [cvc, setCvc] = useState('');
    // const [cardType, setCardType] = useState('default');
    // const [focused, setFocused] = useState('');
    const [loading, setLoading] = useState(false);
    const [cardErrors, setCardErrors] = useState({
        cardNumber: '',
        expiry: '',
        cvc: ''
    });
    const [buttonDisable, setButtonDisable] = useState(false);

    const [state, setState] = useState({
        expanded: false,
        number: "",
        selectButtonAmount: 0.0,
        name: "",
        expiry: "",
        cvc: "",
        issuer: "",
        focused: "",
        formData: null,
        cardNumber: "",
        backgroundImage:"",
        errors: {
          number: "",
          email: "",
          sms: "",
          message: "",
        },
        cardErrors: {
          cardNumber: "",
          expiry: "",
          cvc: "",
        },
        firstLayout: true,
        secondLayout: false,
        generateGiftNumber: 0,
        email: "",
        sms: "",
        message: "",
    });
    const [errorMessage, setErrorMessage] = useState(false);

    const predefinedAmounts = [
        { value: 10, display: '$10.00' },
        { value: 20, display: '$20.00' },
        { value: 50, display: '$50.00' },
        { value: 80, display: '$80.00' },
        { value: 100, display: '$100.00' },
    ];
    // const [isModalOpen, setModalOpen] = useState(false);

    // Add state to control modal rendering
    const [showAuthLayout, setShowAuthLayout] = useState(false);

    // Add new state to control focus lock
    const [giftCardItem, setGiftCardItem] = useState(null);

    const [saveCard, setSaveCard] = useState(false);
    const [isDefaultCard, setIsDefaultCard] = useState(false);
    const cancelRef = useRef();
    const [isOpenes, setIsOpenModal] = useState(false);
    const [deleteSelectedCard, setDeleteSelectedCard] = useState(null);
    const [selectedDefaultCardId, setSelectedDefaultCardId] = useState(null);


    const [showCardForm, setShowCardForm] = useState(() => {
        if(props?.delivery_pickup[0]?.location?.id || props.locationId){
            const hasValidCards = props.user?.user?.user_card_details && 
                                Array.isArray(props.user.user.user_card_details) && 
                                props.user.user.user_card_details.length > 0;
            return !hasValidCards;
        }
        else{
            return true;
        }
    });

    const [selectedCardId, setSelectedCardId] = useState(() => {
        if(props?.delivery_pickup[0]?.location?.id || props.locationId){
            const defaultCard = props.user?.user?.user_card_details?.find(
                (card) => card.is_card_default
            );
            return defaultCard?.id || null;
        }
        return null;
    });
    
    const [selectedCard, setSelectedCard] = useState(() => {
        if(props?.delivery_pickup[0]?.location?.id || props.locationId){
            const defaultCard = props.user?.user?.user_card_details?.find(
                (card) => card.is_card_default
            );
            return defaultCard || null;
        }
        return null;
    });

    const [blocked, setBlocked] = useState(false);
    // Validation helpers
    const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);


    // Add useEffect to reset states when modal opens or closes
    useEffect(() => {
        if (!props.isOpen) {
            resetAllStates();
        }
    }, [props.isOpen]);
    // useEffect(() => {
    //     // Check if user_card_details exists and is a valid array
    //     const hasValidCards = props.user?.user?.user_card_details && 
    //                          Array.isArray(props.user.user.user_card_details) && 
    //                          props.user.user.user_card_details.length > 0;
    //     setShowCardForm(!hasValidCards);

    //     if (hasValidCards) {
    //         const defaultCard = props.user.user.user_card_details.find(
    //             (card) => card.is_card_default
    //         );
    //         setSelectedCardId(defaultCard?.id || null);
    //         setSelectedCard(defaultCard || null);
    //     } else {
    //         // Reset card selection if there are no valid cards
    //         setSelectedCardId(null);
    //         setSelectedCard(null);
    //     }
    // },  [
    //     currentStep,
    //     props.isOpen,
    //     props.user?.user,
    //     props.user?.user?.id, // Watch for changes in number of cards
    //     JSON.stringify(props.user?.user?.user_card_details), // Watch for changes in card details
    // ]); 
        // Add this useEffect to update states when user data changes
        useEffect(() => {            
            // Check if user_card_details exists and is a valid array
            const hasValidCards = props.user?.user?.user_card_details && 
                                 Array.isArray(props.user.user.user_card_details) && 
                                 props.user.user.user_card_details.length > 0 && (props?.delivery_pickup[0]?.location?.id || props.locationId);
            
            setShowCardForm(!hasValidCards);
        
            if (hasValidCards) {
                const defaultCard = props.user.user.user_card_details.find(
                    (card) => card.is_card_default
                );
                setSelectedCardId(defaultCard?.id || null);
                setSelectedCard(defaultCard || null);
            } else {
                // Reset card selection if there are no valid cards
                setSelectedCardId(null);
                setSelectedCard(null);
            }
        }, [
                currentStep,
                props.isOpen,
                props.user?.user,
                props.user?.user?.id, // Watch for changes in number of cards
                JSON.stringify(props.user?.user?.user_card_details),]); 

    const validationSchemaGiftCard = Yup.object().shape({
        email: Yup.string()
            .matches(Constants.EMAIL_REGEX, Constants.USER_EMAIL_NOT_VALID)
            .max(255, Constants.USER_EMAIL_LESS_THEN_OR_EQUAL_255_CHARACTER)
            .nullable(),
        phone: Yup.string()
            .matches(/^[0-9\b]+$/, Constants.USER_PHONE_NUMBER__NOT_VALID)
            .min(3, Constants.USER_PHONE_NUMBER_MUST_BE_3_DIGITS)
            .max(10, Constants.USER_PHONE_NUMBER_GREATER_THEN_10)
            .nullable(),
        message: Yup.string()
            .max(255, Constants.GIFT_CARD_INSTRUCTION),
    }, [['email', 'phone']]).test( // Add the dependencies array
        'at-least-one-contact',
        Constants.GIFT_CARD_EMAIL_PHONE_REQUIRED,
        function(values) {
            return Boolean(values.email) || Boolean(values.phone);
        }
    );
    
    // You'll need to add this to handle circular dependencies in the when conditions
    validationSchemaGiftCard.fields.email = validationSchemaGiftCard.fields.email.when('phone', {
        is: (phone) => !phone || phone.length === 0,
        then: (schema) => schema.required(Constants.GIFT_CARD_EMAIL_PHONE_REQUIRED),
        otherwise: (schema) => schema.notRequired()
    });
    
    validationSchemaGiftCard.fields.phone = validationSchemaGiftCard.fields.phone.when('email', {
        is: (email) => !email || email.length === 0,
        then: (schema) => schema.required(Constants.GIFT_CARD_EMAIL_PHONE_REQUIRED),
        otherwise: (schema) => schema.notRequired()
    });

    const makePayment = async () => {
        setLoading(true);
        setButtonDisable(true);
        setBlocked(true);
        if (isValidObject(props.user.user)) {
            if (!showCardForm) {
                let user = props.user.user;
                props.addPaymentCardId(user);
                if (
                    props.user.whoIsThis !== null &&
                    props.user.whoIsThis != undefined &&
                    props.user.whoIsThis != ""
                ) {
                    if (
                        props.user.user.first_name !==
                            props.user.whoIsThis.first_name ||
                        props.user.user.last_name !==
                            props.user.whoIsThis.last_name ||
                        props.user.user.phone !== props.user.whoIsThis.phone
                    ) {
                        let payload = {
                            first_name: props.user.whoIsThis.first_name,
                            last_name: props.user.whoIsThis.last_name,
                            phone: props.user.whoIsThis.phone,
                        };
                        props.orderUser(payload);
                    }
                }
                // formikCardDetails.handleSubmit();
                handlePaymentSubmit();
            } else {
                if (isValidInput(formikCardDetails.values.cardNumber)) {
                    if (isValidInput(formikCardDetails.values.expiry)) {
                        if (isValidInput(formikCardDetails.values.cvc)) {
                            const usingSplit =
                                formikCardDetails.values.cardNumber.split(" ");
                            const date = formikCardDetails.values.expiry.split(" ");
                            let year = moment().format("YYYY");
                            let expiry =
                                year.slice(0, 2) +
                                date[0].slice(3, 5) +
                                "-" +
                                date[0].slice(0, 2);
                            let cardNumber = "";

                            if (usingSplit.length > 0) {
                                usingSplit.map((code) => {
                                    cardNumber = cardNumber + code;
                                });
                            }
                            let user = props.user.user;
                            user.selected_card_id = "";
                            let payload = {
                                card_number: cardNumber,
                                expiration_date: expiry,
                                cvv_no: formikCardDetails.values.cvc.trim(),
                                address: props.user.user.address,
                                zip: props.user.user.zipcode,
                            };
                            if (isValidObject(payload)) {
                                props.addUserCardDetails(payload);
                                props.addPaymentCardId(user);
                                if (
                                    props.user.whoIsThis !== null &&
                                    props.user.whoIsThis != undefined &&
                                    props.user.whoIsThis != ""
                                ) {
                                    if (
                                        props.user.user.first_name !==
                                            props.user.whoIsThis.first_name ||
                                        props.user.user.last_name !==
                                            props.user.whoIsThis.last_name ||
                                        props.user.user.phone !==
                                            props.user.whoIsThis.phone
                                    ) {
                                        let payload = {
                                            first_name:
                                                props.user.whoIsThis.first_name,
                                            last_name:
                                                props.user.whoIsThis.last_name,
                                            phone: props.user.whoIsThis.phone,
                                        };
                                        props.orderUser(payload);
                                    }
                                }
                                formikCardDetails.handleSubmit();
                            }
                        } else {
                            setLoading(false);
                            setButtonDisable(false);
                            setBlocked(false);
                            // addToast({
                            //     alertStatus: Constants.TOAST_TYPE_WARNING,
                            //     alertTitle: Constants.TOAST_HEADING_WARNING,
                            //     alertDescription: Constants.CVC_REQUIRED,
                            // });
                            setErrorMessage({error: true, message: Constants.CVC_REQUIRED});
                            setTimeout(() => {
                                setErrorMessage({});
                            }, 5000);
                        }
                    } else {
                        setLoading(false);
                        setButtonDisable(false);
                        setBlocked(false);
                        // addToast({
                        //     alertStatus: Constants.TOAST_TYPE_WARNING,
                        //     alertTitle: Constants.TOAST_HEADING_WARNING,
                        //     alertDescription: Constants.EXPIRY_DATE_REQUIRED,
                        // });
                        setErrorMessage({error: true, message: Constants.EXPIRY_DATE_REQUIRED});
                        setTimeout(() => {
                            setErrorMessage({});
                        }, 5000);
                    }
                } else {
                    setLoading(false);
                    setButtonDisable(false);
                    setBlocked(false);
                    // addToast({
                    //     alertStatus: Constants.TOAST_TYPE_WARNING,
                    //     alertTitle: Constants.TOAST_HEADING_WARNING,
                    //     alertDescription: Constants.CARD_NUMBER_REQUIRED,
                    // });
                    setErrorMessage({error: true, message: Constants.CARD_NUMBER_REQUIRED});
                    setTimeout(() => {
                        setErrorMessage({});
                    }, 5000);
                }
            }
        } else {
            setLoading(false);
            setButtonDisable(false);
            setBlocked(false);
            // addToast({
            //     alertStatus: Constants.TOAST_TYPE_WARNING,
            //     alertTitle: Constants.TOAST_HEADING_WARNING,
            //     alertDescription: Constants.CHECKOUT_PAGE_USER_LOGOUT,
            // });
            setErrorMessage({error: true, message: Constants.CHECKOUT_PAGE_USER_LOGOUT});
            setTimeout(() => {
                setErrorMessage({});
            }, 5000);
        }
    };
    const formikGiftCard = useFormik({
        initialValues: {
            email: '',
            phone: '',
            message: ''
        },
        validationSchema: validationSchemaGiftCard,
        validateOnBlur: true,
        validateOnChange: true,
        validateOnMount: true,
        onSubmit: async (values) => {
            setButtonDisable(true);
            try {
                setRecipientEmail(values.email);
                setRecipientPhone(values.phone);
                setCustomMessage(values.message);
                await handleSubmit(values.email, values.phone, values.message);
            } catch (error) {
                setButtonDisable(false);
                // error({ actionData: error });
                let popupError = error({ actionData: error });
                if (popupError.error) {
                    setErrorMessage(popupError);
                    setTimeout(() => {
                        setErrorMessage({});
                    }, 5000);
                }
            }
        }
    });

    const validateCardNumber = (number) => {
        const usingSplit = number.split(" ");
        let cardNumber = "";
        if (usingSplit.length > 0) {
        usingSplit.map((code) => {
            cardNumber = cardNumber + code;
        });
        }
        const regex =
        /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|62[0-9]{14})$/;
        return regex.test(cardNumber);
    };

    const validateExpiryDate = (value) => {
        const regex = /^(0[1-9]|1[0-2])\/\d{2}$/;
        if (!regex.test(value)) return false;
        const [month, year] = value.split("/");
        const expiryDate = moment(`${month}/01/20${year}`, "MM/DD/YYYY");
        return expiryDate.isAfter(moment());
    };

    const validateCVCNumber = (cvc) => {
        const regex =  /^[0-9]{3,4}$/;
        return regex.test(cvc);
    };

    const formikCardDetails = useFormik({
        initialValues: {
            cardNumber: "",
            expiry: "",
            cvc: "",
        },
        validationSchema: Yup.object({
            cardNumber: Yup.string()
                .required(Constants.CARD_NUMBER_REQUIRED)
                .test(
                    "isValidCardNumber",
                    Constants.VALID_CARD_NUMBER,
                    validateCardNumber
                ),
                expiry: Yup.string()
                .required(Constants.EXPIRY_DATE_REQUIRED)
                .test(
                    "isValidExpiryDate",
                    Constants.VALID_EXPIRY_DATE,
                    (value) => validateExpiryDate(value)
                ),
            cvc: Yup.string()
                .required(Constants.CVC_REQUIRED)
                .test("isValidCVC", Constants.VALID_CVC, validateCVCNumber)
        }),
        onSubmit: (values) => {
            setButtonDisable(true);
            try {
                handlePaymentSubmit();
            } catch (error) {
                setButtonDisable(false);
                // error({ actionData: error });
                let popupError = error({ actionData: error });
                if (popupError.error) {
                    setErrorMessage(popupError);
                    setTimeout(() => {
                        setErrorMessage({});
                    }, 5000);
                }
            }
        },
    });

    // Custom handler for card input formatting
const handleCardFormat = (e) => {
    const { id, value } = e.target;
    if (!value.startsWith(' ')) {  // Prevent leading spaces
        let formattedValue = value;

        if (id === "cardNumber") {
            formattedValue = formatCreditCardNumber(value);
        } else if (id === "expiry") {
            formattedValue = formatExpirationDate(value);
        } else if (id === "cvc") {
            formattedValue = formatCVC(value);
        }

        formikCardDetails.setFieldValue(id, formattedValue);
    }
};
    
    const validate = (number) => {
        const regex = /^\d+(\.\d{1,2})?$/;
        return regex.test(number.trim());
    };

    // const validatephone = (phone) => {
    //     const regex = /^[0-9\b]+$/;
    //     return regex.test(phone);
    // };

    // Amount handling
    const handleAmountSelect = (amount) => {
        setErrorMessage({error: false, message: '', amount: false, email:false});
        setSelectedAmount(amount);
        setCustomAmount('');
        setErrors(prev => ({ ...prev, number: '' }));
    };
    const handleCloseModal = () => {
        resetAllStates();
        props.onClose();
    };

    const handleCloseDeleteCard = () => {
        setIsOpenModal(false);
    };

    const handleCustomAmountChange = (e) => {
        const value = e.target.value;
        let newErrors = { ...errors };

        if(null == value || value === ''){
            setCustomAmount('');
            setErrors({
                ...errors,
                number: Constants.GIFT_CARD_AMOUNT_REQUIRED
            });
            return;
        }
        if (value.length > 0) {
            if (!validate(value)) {
                newErrors.number = Constants.VALID_GIFT_CARD_AMOUNT;
            } else if (parseFloat(value) <= 0 || parseFloat(value) > 500) {
                newErrors.number = Constants.VALID_GIFT_CARD_AMOUNT_LESS_OR_GREATER;
            } else {
                newErrors.number = '';
            }
        } else {
            newErrors.number = '';
        }
        
        setErrors(newErrors);
        setCustomAmount(value);
        setSelectedAmount(null);
        setErrorMessage({error: false, message: '', amount: false, email:false});
    };

    // const handleCustomAmountBlur = (e) => {
    //     const value = e.target.value;
    //     if (value && value.length > 0) {
    //         const formattedValue = twofix(value).toFixed(2);
    //         setCustomAmount(formattedValue);
            
    //         // Validate the formatted amount
    //         let newErrors = { ...errors };
    //         if (parseFloat(formattedValue) <= 0 || parseFloat(formattedValue) > 500) {
    //             newErrors.number = 'Amount must be between $0.01 to $500.00';
    //         } else {
    //             newErrors.number = '';
    //         }
    //         setErrors(newErrors);
    //     }
    // };
    const handleCustomAmountBlur = (e) => {
        if(selectedAmount){
            return;
        }
        const value = e.target.value;
        
        if(null == value || value === ''){
            setCustomAmount('');
            setErrors({
                ...errors,
                number: Constants.GIFT_CARD_AMOUNT_REQUIRED
            });
            return;
        }
        // Check for invalid inputs (empty, just decimal, non-numeric)
        if (value === '.' || isNaN(parseFloat(value))) {
            setCustomAmount('');
            setErrors({
                ...errors,
                number: Constants.GIFT_CARD_AMOUNT_REQUIRED_ERROR
            });
            return;
        }
    
        // Format valid number
        const numericValue = parseFloat(value);
        const formattedValue = twofix(numericValue).toFixed(2);
        
        // Validate the amount range
        if (numericValue <= 0 || numericValue > 500) {
            setCustomAmount(formattedValue);
            setErrors({
                ...errors,
                number: Constants.GIFT_CARD_AMOUNT_REQUIRED_ERROR
            });
        } else {
            setCustomAmount(formattedValue);
            setErrors({
                ...errors,
                number: ''
            });
        }
    };

    // Gift card number generation
    const generateGiftCardNumber = () => {
        const number = Math.floor(Math.random() * (999 - 100)) + 101;
        const number2 = Math.floor(Math.random() * (999 - 100)) + 101;
        const number3 = Math.floor(Math.random() * (999 - 100)) + 101;
        const number4 = Math.floor(Math.random() * (999 - 100)) + 101;
        const fullNumber = `${number}${number2}${number3}${number4}`;
        const maskedNumber = `${'*'.repeat(8)}${fullNumber.slice(-4)}`;
        return { fullNumber, maskedNumber };
    };

    // Input handling
    // const handleInputChange = (event) => {
    //     const { name, value } = event.target;
    //     let newErrors = { ...errors };

    //     switch (name) {
    //         case 'email':
    //             newErrors.email = value.length > 0
    //                 ? validEmailRegex.test(value)
    //                     ? value.length < 255
    //                         ? ""
    //                         : Constants.USER_EMAIL_LESS_THEN_OR_EQUAL_255_CHARACTER
    //                     : Constants.USER_EMAIL_NOT_VALID
    //                 : "";
    //             setRecipientEmail(value);
    //             break;
    //         case 'sms':
    //             newErrors.sms = value.length > 0
    //                 ? validatephone(value)
    //                     ? value.length > 10
    //                         ? Constants.USER_PHONE_NUMBER_GREATER_THEN_10
    //                         : value.length < 3
    //                             ? Constants.USER_PHONE_NUMBER_MUST_BE_3_DIGITS
    //                             : ""
    //                     : Constants.USER_PHONE_NUMBER__NOT_VALID
    //                 : "";
    //             setRecipientPhone(value);
    //             break;
    //         case 'message':
    //             newErrors.message = value.length > 0
    //                 ? value.length > 255
    //                     ? Constants.GIFT_CARD_INSTRUCTION
    //                     : ""
    //                 : "";
    //             setCustomMessage(value);
    //             break;
    //             default:
    //             break;
    //     }
    //     setErrors(newErrors);
    // };

    // Form submission
    const handleSubmit = async (emailAddress, phoneNumber, giftCardCustomMessage) => { 
        setButtonDisable(true);
        setLoading(true);
        // if (props.order_items?.length > 0) {
        //     addToast({
        //         alertStatus: Constants.TOAST_TYPE_WARNING,
        //         alertTitle: Constants.TOAST_HEADING_WARNING,
        //         alertDescription:Constants.CAN_NOT_ADD_GIFT_CARD,
        //     });
        //     return;
        // }        
        const amount = selectedAmount || parseFloat(customAmount);
        const barcode = giftCardCode;
        
        try {
            // const response = await checkGiftCardNumber(barcode);
            // if (response?.error) {
            //     if (response.response.data.code === 999) {
            //         const product = {
            //             name: "Gift Card",
            //             sale_price: (Math.round(amount * 100) / 100).toFixed(2),
            //             server_id: barcode,
            //             tax_percentage: 0,
            //             tax_amount: 0,
            //             extra_item: 0,
            //             Ebt_item: 1,
            //             taxes: [],
            //             tax_collected: 0,
            //             gift_card: 1,
            //             type: "eGiftCard",
            //             email: recipientEmail,
            //             sms: recipientPhone,
            //             print_receipt: false,
            //             product_description: customMessage,
            //         };

            //         // Handle session expiration
            //         props.currentItem(product);
            //         props.removeUserCardDetails();
            //         props.userLogout();
            //         localStorage.removeItem("token");
            //         handleSignInRequired();
            //     }
            //     error({ actionData: response });
            //     setButtonDisable(false);
            // } else if (response.data.flag) {
            //     const item = {
            //         name: "Gift Card",
            //         sale_price: (Math.round(amount * 100) / 100).toFixed(2),
            //         server_id: barcode,
            //         tax_percentage: 0,
            //         tax_amount: 0,
            //         extra_item: 0,
            //         Ebt_item: 1,
            //         taxes: [],
            //         tax_collected: 0,
            //         gift_card: 1,
            //         type: "eGiftCard",
            //         email: recipientEmail,
            //         sms: recipientPhone,
            //         print_receipt: false,
            //         product_description: customMessage,
            //     };
            //     // Call reducers in sequence
            //     props.currentItem(item);
            //     props.addExtraItem(item);
            //     props.orderCalculation();
            //     setCurrentStep(3);
            //     setButtonDisable(false);
            // } 
            // else {
            //     if (response.data.code === 999) {
            //         const product = {
            //             name: "Gift Card",
            //             sale_price: (Math.round(amount * 100) / 100).toFixed(2),
            //             server_id: barcode,
            //             tax_percentage: 0,
            //             tax_amount: 0,
            //             extra_item: 0,
            //             Ebt_item: 1,
            //             taxes: [],
            //             tax_collected: 0,
            //             gift_card: 1,
            //             type: "eGiftCard",
            //             email: recipientEmail,
            //             sms: recipientPhone,
            //             print_receipt: false,
            //             product_description: customMessage,
            //         };

            //         // Handle session expiration
            //         props.currentItem(product);
            //         props.removeUserCardDetails();
            //         props.userLogout();
            //         localStorage.removeItem("token");
            //         handleSignInRequired();
            //         error({ actionData: response });
            //         setButtonDisable(false);
            //     }
            //     addToast({
            //         alertStatus: Constants.TOAST_TYPE_WARNING,
            //         alertTitle: Constants.TOAST_HEADING_WARNING,
            //         alertDescription:response.data.message,
            //     });
            //     setButtonDisable(false);
            // }
            checkGiftCardNumber(barcode).then((response) => {
                if(response.error){
                    if(response?.response?.status === Constants.UNAUTHORIZE_CODE){
                        // error({ actionData: response });
                        dialogError.error({ actionData: response });
                        handleSignInRequired();
                    }
                    else{
                        let popupError = error({ actionData: response });
                        if (popupError.error) {
                            setErrorMessage(popupError);
                            setTimeout(() => {
                                setErrorMessage({});
                            }, 5000);
                        }
                    }

                    setLoading(false);
                    setButtonDisable(false);
                    // error({ actionData: response });
                    // let popupError = error({ actionData: response });
                    // if (popupError.error) {
                    //     setErrorMessage(popupError);
                    //     setTimeout(() => {
                    //         setErrorMessage({});
                    //     }, 5000);
                    // }
                }
                else if(response.data.flag){
                    if (store.getState().user?.user && (props?.delivery_pickup[0]?.location?.id || props.locationId)) {
                        try {
                            getUserCardDetails(store.getState().user?.user.id, props?.delivery_pickup[0]?.location?.id || props.locationId)
                                .then((response) => {
                                    if (
                                        undefined !== response.data.flag &&
                                        null !== response.data.flag &&
                                        response.data.flag == true
                                    ) {
                                        props.userLogin(response.data.data);
                                        if(store.getState().user?.user?.user_card_details?.length > 0){
                                            setShowCardForm(false);
                                        }
                                    } else {
                                        let actionData = response.data;
                                        const { shouldOpenAuthModal } = error({
                                            actionData,
                                        });
                                    }
                                })
                                .catch((err) => {
                                    // let actionData = err;
                                    let actionData = err;
                                    const { shouldOpenAuthModal } = error({ actionData });
                                });
                        } catch (error) {
                            let actionData = error;
                            addToast({
                                isBottomToast: true,
                                alertStatus: Constants.TOAST_TYPE_WARNING,
                                alertTitle: Constants.TOAST_HEADING_WARNING,
                                alertDescription: actionData.response.data.message,
                            });
                        }
                    }
                    // const item = {
                    //     name: "Gift Card",
                    //     sale_price: (Math.round(amount * 100) / 100).toFixed(2),
                    //     server_id: barcode,
                    //     tax_percentage: 0,
                    //     tax_amount: 0,
                    //     extra_item: 0,
                    //     Ebt_item: 1,
                    //     taxes: [],
                    //     tax_collected: 0,
                    //     gift_card: 1,
                    //     type: "eGiftCard",
                    //     email: recipientEmail,
                    //     sms: recipientPhone,
                    //     print_receipt: false,
                    //     product_description: customMessage,
                    // };
                    let pushItem = {
                        // create item new Object
                        server_id: barcode,
                        product_id: barcode,
                        extra_item: 0,
                        gift_card: 1,
                        quantity: 1,
                        name: "Gift Card",
                        regular_price: 0,
                        Ebt_item: 1,
                        sale_price: (Math.round(amount * 100) / 100).toFixed(2),
                        tax_percentage: 0,
                        tax_amount: 0,
                        tax_collected: 0,
                        reward_points: 0,
                        discount_percentage: 0,
                        total_discount: 0,
                        discount_reason: '',
                        discount_type: '',
                        sold_by_weight: 0,
                        prompt_qty: 0,
                        barcode: barcode,
                        taxes: [],
                        exclude_ebt: 0,
                        ebt_tax: 0,
                        cash_discount_amount: 0,
                        new_identity: twofix(Math.floor(10000000 + Math.random() * 90000000)),
                        modifier_set: [],
                        total_modifiers_price: 0,
                        is_modifier_product: 0,
                        for_here: 0,
                        total_promotion_apply_product: [],
                        barcode_scanned: [],
                        type: "eGiftCard",
                        email: emailAddress,
                        phone: phoneNumber,
                        print_receipt: false,
                        product_description: giftCardCustomMessage,
                        description: giftCardCustomMessage,
                    }
                    setGiftCardItem(pushItem);
                    // Call reducers in sequence
                    // props.currentItem(pushItem);
                    // props.addExtraItem(pushItem);
                    props.orderCalculation();
                    setCurrentStep(3);
                    setButtonDisable(false);
                    setLoading(false);
                }
            }).catch((err) => {
                setLoading(false);
                setButtonDisable(false);
                if(err?.response?.status === Constants.UNAUTHORIZE_CODE){
                    error({ actionData: err });
                    handleSignInRequired();
                }
                else{
                let popupError = error({ actionData: err });
                if (popupError.error) {
                    setErrorMessage(popupError);
                    setTimeout(() => {
                        setErrorMessage({});
                        }, 5000);
                    }
                }
            });
        } catch (error) {
            setLoading(false);
            setButtonDisable(false);
            if (error.toString() === Constants.BACKEND_ERROR || 
                error.toString() === Constants.BACKEND_ERROR_CODE) {
                // addToast({
                //     alertStatus: Constants.TOAST_TYPE_WARNING,
                //     alertTitle: Constants.TOAST_HEADING_WARNING,
                //     alertDescription:Constants.SERVER_NOT_AVAILABLE,
                // });
                // let popupError = error({ actionData: error });
                // if (popupError.error) {
                    setErrorMessage({error: true, message: Constants.SERVER_NOT_AVAILABLE});
                    setTimeout(() => {
                        setErrorMessage({});
                    }, 5000);
                // }
            } else {
                // addToast({
                //     alertStatus: Constants.TOAST_TYPE_WARNING,
                //     alertTitle: Constants.TOAST_HEADING_WARNING,
                //     alertDescription:error.toString(),
                // });
                // let popupError = error({ actionData: error });
                // if (popupError.error) {
                    setErrorMessage({error: true, message: error.toString()});
                    setTimeout(() => {
                        setErrorMessage({});
                    }, 5000);
                // }
            }
        }
    };

    const handleSignInRequired = () => {
        // Temporarily disable focus trap on gift card modal
        // Add a small delay before opening the sign-in modal
        setTimeout(() => {
            setSignInModalOpen(true);
            setShowAuthLayout(true);
        }, 100);
    };

    const handleCloseSignInModal = () => {
        setSignInModalOpen(false);
        if(null != localStorage.getItem("token") && '' != localStorage.getItem("token")){
            setCurrentStep(3);
            handleSubmit(recipientEmail, recipientPhone, customMessage);
        }
        // setShowAuthLayout(false);
    };

    // const handleCardInputChange = (e) => {
    //     const { name, value } = e.target;
    //     let newErrors = { ...cardErrors };
    //     if (e.target.name === "cardNumber") {
    //         e.target.value = formatCreditCardNumber(e.target.value);
    //     } else if (e.target.name === "expiry") {
    //         e.target.value = formatExpirationDate(e.target.value);
    //     } else if (e.target.name === "cvc") {
    //         e.target.value = formatCVC(e.target.value);
    //     }
    //     const date = e.target.value.split(" ");
    //     let year = moment().format("YYYY");
    //     let expiry = year.slice(0, 2) + date[0].slice(3, 5);
    //     switch (name) {
    //         case 'cardNumber':
    //             cardErrors.cardNumber =
    //             e.target.value.length === 0
    //               ? Constants.CARD_NUMBER_REQUIRED
    //               : validateCardNumber(e.target.value)
    //                 ? ""
    //                 : Constants.VALID_CARD_NUMBER;
    //           break;
    //         case 'expiry':
    //             cardErrors.expiry =
    //             e.target.value.length === 0
    //                 ? Constants.EXPIRY_DATE_REQUIRED
    //                 : validateExpiryDate(e.target.value)
    //                 ? moment(moment(e.target.value, ["MM/YY"])).isAfter(new Date(), [
    //                     "MM/YY",
    //                     ]) ||
    //                     moment(moment(expiry, ["YYYY"])).isAfter(new Date(), ["YYYY"])
    //                     ? ""
    //                     : Constants.PAST_EXPIRY_DATE
    //                 : Constants.VALID_EXPIRY_DATE;
    //             break;

    //         case 'cvc':
    //             cardErrors.cvc =
    //                 e.target.value.length === 0
    //                     ? Constants.CVC_REQUIRED
    //                     : validateCVCNumber(e.target.value)
    //                     ? ""
    //                     : Constants.VALID_CVC;
    //             break;

    //         default:
    //         break;
    //     }
    //     setCardErrors(cardErrors);
    //     setState({ ...state, [e.target.name]: e.target.value });
    // };

    const getFormattedAmount = () => {
        const amount = selectedAmount || parseFloat(customAmount) || 0;
        return amount.toFixed(2);
    };

    const renderAmountSelection = () => (
        <VStack spacing={4} align="stretch">
            <Box width="100%">
                <HomeText 
                    isLabelText={true} 
                    name="Select the Amount" 
                    mb={2} 
                    textAlign="center" 
                />
                
                {/* First row */}
                <Flex 
                    justify="center" 
                    gap={2} 
                    width="100%"
                    mb={4}
                >
                    {predefinedAmounts.slice(0, 2).map((amount) => (
                        <GrubFormButton
                            key={amount.value}
                            buttonsubmit={amount.display}
                            width={{ base: "100%", md: "100%" }}
                            height={{ base: "2.5rem", md: "2.5rem" }}
                            bg={selectedAmount === amount.value ? Colors.primeTaxInfo : Colors.posTextInfo}
                            onClick={() => handleAmountSelect(amount.value)}
                        />
                    ))}
                </Flex>
                
                {/* Second row */}
                <Flex 
                    justify="center" 
                    gap={2} 
                    width="100%"
                    mt={4}
                    // flexWrap="wrap"
                >
                    {predefinedAmounts.slice(2).map((amount) => (
                        <GrubFormButton
                            key={amount.value}
                            buttonsubmit={amount.display}
                            width={{ base: "100%", md: "100%" }}
                            height={{ base: "2.5rem", md: "2.5rem" }}
                            bg={selectedAmount === amount.value ? Colors.primeTaxInfo : Colors.posTextInfo}
                            onClick={() => handleAmountSelect(amount.value)}
                        />
                    ))}
                </Flex>
            </Box>

            <Box>
                <HomeText isLabelText={true} name="OR" mb={2} />
                <HomeText isLabelText={true} name="Custom Amount" mb={2} />
                <HomeText isText={true} name="Tap below to enter the custom amount." mb={1} />
                {/* <Input
                    placeholder="Enter an amount"
                    value={customAmount}
                    onChange={handleCustomAmountChange}
                    onBlur={handleCustomAmountBlur}
                    type="number"
                    min="0"
                    step="0.01"
                /> */}
                <GrubInput
                    posNumberInput={true}
                    placeholder="Enter an amount"
                    inputValue={customAmount}
                    handleInputChange={handleCustomAmountChange}
                    handleBlur={handleCustomAmountBlur}
                    inputError={errors.number}
                />
                {errors.number && (
                    <Text color="red.500" fontSize="sm" mt={1}>
                        {errors.number}
                    </Text>
                )}
            </Box>

            {/* {errorMessage && errorMessage.error && errorMessage.message && (
                <GrubErrorMessage
                    errorMessage={errorMessage.message}
                    width={"auto"}
                />
            )} */}
            <Flex spacing={2} mt={2} mb={4} justifyContent="flex-end">
                {/* <GrubFormButton
                    buttonsubmit="GO HOME"
                    width="50%"
                    bg={Colors.posTextInfo}
                    onClick={() => {
                        props.onClose();
                    }}
                /> */}
                <GrubFormButton
                    buttonsubmit="CONTINUE"
                    width={{base: "45%", md: "33%"}}
                    bg={Colors.posTextInfo}
                    // isDisabled={(!selectedAmount && !customAmount) || errors.number}
                    onClick={() => {
                        if((!selectedAmount && !customAmount) || errors.number) {
                            if(!selectedAmount && !customAmount){
                                setErrors({...errors, number: Constants.GIFT_CARD_AMOUNT_REQUIRED});
                                return;
                            }
                            else if(errors.number) {
                                setErrors({...errors, number: errors.number});
                                setTimeout(() => {
                                    setErrors({...errors, number: ""});
                                }, 5000);
                                return;
                            }
                        }
                        const { fullNumber, maskedNumber } = generateGiftCardNumber();
                        setGiftCardCode(fullNumber);
                        setMaskedGiftCardCode(maskedNumber);
                        setCurrentStep(2);
                    }}
                />
            </Flex>
        </VStack>
    );

    const handleBackClick = (step) => {
        // props.clearItems();
        setCurrentStep(step);
    };

    useEffect(() => {
        if (props.isOpen && currentStep === 2) {  // Step 2 is gift card details
            const emailInput = document.getElementById('email');
            if (emailInput) {
                emailInput.focus();
            }
        }
        if(props.isOpen && currentStep === 3 && showCardForm){
            const cardNumber = document.getElementById('cardNumber');
            if (cardNumber) {
                cardNumber.focus();
            }
        }
    }, [props.isOpen, currentStep, showCardForm]);

    const renderGiftCardDetails = () => (
        <VStack spacing={2} align="stretch">
            <Box>
                <HomeText isLabelText={true} name="Gift Card Code" mb={2} />
                <Button
                    variant="contained"
                    style={{
                        width: "100%",
                        height: "3rem",
                        backgroundColor: "#757575",
                        color: "#fff",
                        fontSize: 22,
                        fontWeight: 'bold'
                    }}
                    size="large"
                    tabIndex={-1}
                >
                    {maskedGiftCardCode}
                </Button>
            </Box>

            {/* <Box>
                <HomeText isLabelText={true} name="Email this Gift Card" mb={2} />
                <Input
                    name="email"
                    placeholder="Enter the email address of the recipient"
                    value={recipientEmail}
                    onChange={handleInputChange}
                    type="email"
                    isInvalid={errors.email !== ''}
                />
                {errors.email && (
                    <Text color="red.500" fontSize="sm">{errors.email}</Text>
                )}
            </Box>

            <Box>
                <HomeText isLabelText={true} name="OR" mb={2} />
            </Box>

            <Box>
                <HomeText isLabelText={true} name="SMS this Gift Card" mb={2} />
                <Input
                    name="sms"
                    placeholder="Enter the Phone Number of the recipient"
                    value={recipientPhone}
                    onChange={handleInputChange}
                    type="tel"
                    isInvalid={errors.sms !== ''}
                />
                {errors.sms && (
                    <Text color="red.500" fontSize="sm">{errors.sms}</Text>
                )}
            </Box>

            <Box>
                <HomeText isLabelText={true} name="Custom Message" mb={2} />
                <Input
                    name="message"
                    placeholder="Enter the Custom Message of the recipient"
                    value={customMessage}
                    onChange={handleInputChange}
                    isInvalid={errors.message !== ''}
                />
                {errors.message && (
                    <Text color="red.500" fontSize="sm">{errors.message}</Text>
                )}
            </Box>

            <HStack spacing={4} mt={4}>
                <GrubFormButton
                    buttonsubmit="BACK"
                    width="50%"
                    bg={Colors.posTextInfo}
                    onClick={() => handleBackClick(1)}
                    isDisabled={loading}
                />
                <GrubFormButton
                    buttonsubmit="CONTINUE"
                    width="50%"
                    bg={Colors.posTextInfo}
                    isDisabled={
                        buttonDisable ||
                        (!recipientEmail && !recipientPhone) ||
                        errors.email !== '' ||
                        errors.sms !== ''
                    }
                    onClick={handleSubmit}
                />
            </HStack> */}
            <Box>
                <HomeText isLabelText={true} name="Email this Gift Card" mb={2} />
                {/* <Input
                    name="email"
                    placeholder="Enter the email address of the recipient"
                    {...formikGiftCard.getFieldProps('email')}
                    isInvalid={formikGiftCard.touched.email && formikGiftCard.errors.email}
                /> */}
                <GrubInput
                    id="email"
                    posInput={true}
                    placeholder="Enter the email address of the recipient"
                    inputValue={formikGiftCard.values.email}
                    handleInputChange={(e) => {
                        if (!e.target.value.startsWith(' ')) {
                            formikGiftCard.handleChange(e);
                            setErrorMessage({error: false, message: ""});
                        }
                    }}
                    handleBlur={formikGiftCard.handleBlur}
                    inputError={formikGiftCard.touched.email && formikGiftCard.errors.email}
                />
                {formikGiftCard.touched.email && formikGiftCard.errors.email && (
                    <Text color="red.500" fontSize="sm">{formikGiftCard.errors.email}</Text>
                )}
            </Box>

            <Box>
                <HomeText isLabelText={true} name="OR" mb={2} />
            </Box>

            <Box>
                <HomeText isLabelText={true} name="SMS this Gift Card" mb={2} />
                {/* <Input
                    name="phone"
                    placeholder="Enter the Phone Number of the recipient"
                    {...formikGiftCard.getFieldProps('phone')}
                    type="tel"
                    isInvalid={formikGiftCard.touched.phone && formikGiftCard.errors.phone}
                /> */}
                <GrubInput
                    id="phone"
                    posInput={true}
                    placeholder="Enter the phone number of the recipient"
                    inputValue={formikGiftCard.values.phone}
                    handleInputChange={(e) => {
                        if (!e.target.value.startsWith(' ')) {
                            formikGiftCard.handleChange(e);
                            setErrorMessage({error: false, message: ""});
                        }
                    }}
                    handleBlur={formikGiftCard.handleBlur}
                    inputError={formikGiftCard.touched.phone && formikGiftCard.errors.phone}
                />
                {formikGiftCard.touched.phone && formikGiftCard.errors.phone && (
                    <Text color="red.500" fontSize="sm">{formikGiftCard.errors.phone}</Text>
                )}
            </Box>

            <Box>
                <HomeText isLabelText={true} name="Custom Message" mb={2} />
                {/* <Input
                    name="message"
                    placeholder="Enter the Custom Message of the recipient"
                    {...formikGiftCard.getFieldProps('message')}
                    isInvalid={formikGiftCard.touched.message && formikGiftCard.errors.message}
                /> */}
                <GrubInput
                    id="message"
                    posInput={true}
                    placeholder="Enter the custom message for the recipient"
                    inputValue={formikGiftCard.values.message}
                    handleInputChange={(e) => {
                        if (!e.target.value.startsWith(' ')) {
                            formikGiftCard.handleChange(e);
                        }
                    }}
                    handleBlur={formikGiftCard.handleBlur}
                    inputError={formikGiftCard.touched.message && formikGiftCard.errors.message}
                />
                {formikGiftCard.touched.message && formikGiftCard.errors.message && (
                    <Text color="red.500" fontSize="sm">{formikGiftCard.errors.message}</Text>
                )}
            </Box>

            {errorMessage && errorMessage.error && errorMessage.message && (
                <GrubErrorMessage
                    errorMessage={errorMessage.message}
                    width={"auto"}
                />
            )}
            <HStack spacing={4} mt={4} mb={4}>
                <GrubFormButton
                    buttonsubmit="BACK"
                    width="50%"
                    bg={Colors.posTextInfo}
                    onClick={() => handleBackClick(1)}
                    type="button"
                />
                <GrubFormButton
                    buttonsubmit="CONTINUE"
                    width="50%"
                    bg={Colors.posTextInfo}
                    type="submit"
                    isDisabled={
                        buttonDisable 
                        // ||
                        // (!formikGiftCard.values.email && !formikGiftCard.values.phone) ||
                        // Object.keys(formikGiftCard.errors).length > 0
                    }
                    onClick={() => {
                        if((!formikGiftCard.values.email && !formikGiftCard.values.phone) ||
                        Object.keys(formikGiftCard.errors).length > 0){
                            formikGiftCard.setTouched({
                                email: true,
                                phone: true,
                                message: true
                            });
                            // if(!formikGiftCard.values.email && !formikGiftCard.values.phone){
                            //     setErrorMessage({error: true, message: Constants.GIFT_CARD_EMAIL_PHONE_REQUIRED, amount: false, email:true, phone:true});
                            //     setTimeout(() => {
                            //         setErrorMessage({});
                            //     }, 5000);
                            // }
                            return;
                        }
                        formikGiftCard.handleSubmit();
                    }}
                />
            </HStack>
        </VStack>
    );


    // const handleInputFocus = (e) => {
    //     setFocused(e.target.name);
    // };

    const onOrderSubmit = (payloadCardDetails, existing_card_details) => {
        // this.setState({ loading: true });
        setLoading(true);
        setBlocked(true);
        var amount_t = selectedAmount || customAmount;
        var totalTipPayment = 0;
        var totalPayment = 0;
        if (
          amount_t === "" ||
          amount_t === "0." ||
          "" === parseFloat(amount_t).toFixed(2) ||
          "undefined" === parseFloat(amount_t).toFixed(2) ||
          isNaN(amount_t) ||
          0 === parseFloat(amount_t).toFixed(2) ||
          0.0 === parseFloat(amount_t).toFixed(2)
        ) {
          // 'Input value is undefined,not a number,empty,0.,0.00 or 0'
        //   addToast({
        //     alertStatus: Constants.TOAST_TYPE_WARNING,
        //     alertTitle: Constants.TOAST_HEADING_WARNING,
        //     alertDescription:Constants.ORDER_BALANCE_ZERO,
        // });
        setErrorMessage({error: true, message: Constants.ORDER_BALANCE_ZERO});
        setTimeout(() => {
            setErrorMessage({});
        }, 5000);
          // this.setState({ loading: false });
          setLoading(false);
          setBlocked(false);
        } else {
          processOrder(totalTipPayment, totalPayment, payloadCardDetails, existing_card_details);
        }
      };

      const processOrder = (order_tip_amount, totalPayment, payloadCardDetails, existing_card_details) => {
        // this.elScroll.executeScroll();
        var current_order =
        new Date().valueOf().toString() +
        "" +
        (Math.floor(Math.random() * (999 - 100)) + 101);
        var balance = twofix(
            selectedAmount || customAmount,
        ).toFixed(2);
        let first_name = "";
        let last_name = "";
        let phone = "";
        if (
          isValidObject(props.user.whoIsThis)
        ) {
          first_name = props.user.whoIsThis.first_name;
          last_name = props.user.whoIsThis.last_name;
          phone = props.user.whoIsThis.phone;
        } else {
          if (
            isValidObject(props.user.user)
          ) {
            first_name = props.user.user.first_name;
            last_name = props.user.user.last_name;
            phone = props.user.user.phone;
          }
        }
        if (
          isValidObject(props.user.user)
        ) {
          if (
            isValidObject(payloadCardDetails) || isValidObject(existing_card_details)
          ) {
            var timestamp = new Date().getTime();
            var order_payload = {
              //Create payment payload
              campaign_coupon_id: "",
              reward_history_id: "",
              email: props.user.user.email,
              paid: 1,
              pos_station_id: "",
              reward_card_id: '',
              total: selectedAmount || customAmount,
              local_id: current_order,
              balance: balance,
              discount_amount: 0,
              discount_reason: "",
              lines: [giftCardItem],
              grub_user_id: props.user.user.id,
              payment: [
                {
                  aid: undefined,
                  aid_display_name: undefined,
                  amount: twofix(
                    twofix(selectedAmount || customAmount),
                  ),
                  cash_payment_check: 0,
                  cashback_amount: undefined,
                  external_reference: undefined,
                  external_reference_number: undefined,
                  id: timestamp,
                  multiple_cash: true,
                  payment_gateway: undefined,
                  pin_statement: undefined,
                  tips_amount: order_tip_amount,
                  type: "CARD",
                },
              ],
              ebt_flag: 0,
              created_by: "",
              order_for_here: 0,
              card_details: payloadCardDetails,
              existing_card_details: existing_card_details,
              save_card: saveCard,
              is_card_default: isDefaultCard,
              is_gift_card_create_from_grub: true,
              order_online_details: {
                pos_location_id: props?.delivery_pickup[0]?.location?.id || props.locationId || null
              }
            };
            postOrder(order_payload)
              .then( async (res) => {
                if (res.error) {
                    setLoading(false);
                    setBlocked(false);
                    setButtonDisable(false);
                    // error({ actionData: res });
                    let popupError = error({ actionData: res });
                    if (popupError.error) {
                        setErrorMessage(popupError);
                        setTimeout(() => {
                            setErrorMessage({});
                        }, 5000);
                    }
                } else if (res.data.flag) {
                //   props.completeOrder();
                  //Complete order
                //   localStorage.removeItem("current_order");
                //   props.removeOrderUser();
                //   props.removeUserCardDetails();
                //   props.removeProducts();
                //   props.removeFeaturedProducts();
                //   props.removeCurrentItem();
                //   props.removeDeliveryPickupDetails();
                //   props.removeLocations();
                //   toast.success(Constant.BUY_GIFT_CARD_SUCCESS);
                addToast({
                    alertStatus: Constants.TOAST_TYPE_SUCESS,
                    alertTitle: Constants.TOAST_HEADING_SUCCESS,
                    alertDescription:Constants.BUY_GIFT_CARD_SUCCESS,
                });
                if (res.data.data.user && 
                    res.data.data.user !== 'undefined' && 
                    res.data.data.user !== null && 
                    res.data.data.user !== '') {
                    await props.userLogin(res.data.data.user);
                }
                props.onClose();
                  // this.setState({ loading: false });
                  setLoading(false);
                  setBlocked(false);
                  setButtonDisable(false);
                //   this.backToHome();
                } else if (res.data.data.error) {
                  if (res.data.data.error.code === 400) {
                    // toast.error(res.data.data.error.message[0]);
                    // addToast({
                    //     alertStatus: Constants.TOAST_TYPE_ERROR,
                    //     alertTitle: Constants.TOAST_HEADING_ERROR,
                    //     alertDescription:res.data.data.error.message[0],
                    // });
                    setErrorMessage({error: true, message: res.data.data.error.message[0]});
                    setTimeout(() => {
                        setErrorMessage({});
                    }, 5000);
                    setLoading(false);
                    setBlocked(false);
                    setButtonDisable(false);
                    // error({ actionData: res });
                    let popupError = error({ actionData: res });
                    if (popupError.error) {
                        setErrorMessage(popupError);
                        setTimeout(() => {
                            setErrorMessage({});
                        }, 5000);
                    }
                  } else if (res.data.data.error.code === 404) {
                    // toast.error(res.data.data.error.message);
                    // addToast({
                    //     alertStatus: Constants.TOAST_TYPE_ERROR,
                    //     alertTitle: Constants.TOAST_HEADING_ERROR,
                    //     alertDescription:res.data.data.error.message,
                    // });
                    setErrorMessage({error: true, message: res.data.data.error.message});
                    setTimeout(() => {
                        setErrorMessage({});
                    }, 5000);
                    setLoading(false);
                    setBlocked(false);
                    setButtonDisable(false);
                  }
                } else {
                  if (res.data.code === 999) {
                    // props.removeUserCardDetails();
                    // props.userLogout();
                    // localStorage.removeItem("token");
                    error({ actionData: res });
                    handleSignInRequired();
                  } else {
                    // toast.error(res.data.message);
                    // addToast({
                    //     alertStatus: Constants.TOAST_TYPE_ERROR,
                    //     alertTitle: Constants.TOAST_HEADING_ERROR,
                    //     alertDescription:res.data.message,
                    // });
                    setErrorMessage({error: true, message: res.data.message});
                    setTimeout(() => {
                        setErrorMessage({});
                    }, 5000);
                    setLoading(false);
                    setBlocked(false);
                    setButtonDisable(false);
                  }
                }
              })
              .catch((err) => {  
                // toast.error(error.toString());
                // addToast({
                //     alertStatus: Constants.TOAST_TYPE_ERROR,
                //     alertTitle: Constants.TOAST_HEADING_ERROR,
                //     alertDescription:error.toString(),
                // });
                setLoading(false);
                setBlocked(false);
                setButtonDisable(false);
                if(err?.response?.status === Constants.UNAUTHORIZE_CODE){
                    error({ actionData: err });
                    handleSignInRequired();
                }
                else{
                let popupError = error({ actionData: err });
                if (popupError.error) {
                    setErrorMessage(popupError);
                    setTimeout(() => {
                        setErrorMessage({});
                    }, 5000);
                }
                }
              });
          } else {
            // toast.error(Constant.USER_CARD_DETAILS_NOT_FOUND);
            // addToast({
            //     alertStatus: Constants.TOAST_TYPE_WARNING,
            //     alertTitle: Constants.TOAST_HEADING_WARNING,
            //     alertDescription:Constants.USER_CARD_DETAILS_NOT_FOUND,
            // });
            setErrorMessage({error: true, message: Constants.USER_CARD_DETAILS_NOT_FOUND});
            setTimeout(() => {
                setErrorMessage({});
            }, 5000);
            setLoading(false);
            setButtonDisable(false);
            let actionData = error;
            // error({ actionData });
            let popupError = error({ actionData });
            if (popupError.error) {
                setErrorMessage(popupError);
                setTimeout(() => {
                    setErrorMessage({});
                }, 5000);
            }
          }
        } else {
          // toast.error(Constant.CHECKOUT_PAGE_USER_LOGOUT);
          // addToast({
          //   alertStatus: Constants.TOAST_TYPE_ERROR,
          //   alertTitle: Constants.TOAST_HEADING_ERROR,
          //   alertDescription:Constants.CHECKOUT_PAGE_USER_LOGOUT,
          // });
          setErrorMessage({error: true, message: Constants.CHECKOUT_PAGE_USER_LOGOUT});
          setTimeout(() => {
              setErrorMessage({});
          }, 5000);
          setLoading(false);
          setBlocked(false);
          setButtonDisable(false);
          let actionData = error;
          // error({ actionData });
          let popupError = error({ actionData: error });
          if (popupError.error) {
              setErrorMessage(popupError);
              setTimeout(() => {
                  setErrorMessage({});
              }, 5000);
          }
        }
      };

    const handlePaymentSubmit = () => {
        setLoading(true);
        setButtonDisable(true);
        setBlocked(true);
        if (
            isValidObject(props.user.user)
          ) {
            if(showCardForm){
            if (
                isValidInput(formikCardDetails.values.cardNumber)
            ) {
            if (
                isValidInput(formikCardDetails.values.expiry)
            ) {
                if (
                isValidInput(formikCardDetails.values.cvc)
                ) {
                const usingSplit = formikCardDetails.values.cardNumber.split(" ");
                const date = formikCardDetails.values.expiry.split(" ");
                let year = moment().format("YYYY");
                let expiry =
                    year.slice(0, 2) +
                    date[0].slice(3, 5) +
                    "-" +
                    date[0].slice(0, 2);
                let cardNumber = "";
                // let expiry = ''
    
                if (usingSplit.length > 0) {
                    usingSplit.map((code) => {
                    cardNumber = cardNumber + code;
                    });
                }
                let user = props.user.user;
                user.selected_card_id = "";
                let payloadCardDetails = {
                    card_number: cardNumber,
                    expiration_date: expiry,
                    cvv_no: formikCardDetails.values.cvc.trim(),
                    address: props.user.user.address,
                    zip: props.user.user.zipcode,
                };
                if (isValidObject(payloadCardDetails)) {
                    // props.addUserCardDetails(payloadCardDetails);
                    props.addPaymentCardId(user);
                    if (
                    isValidObject(props.user.whoIsThis)
                    ) {
                    if (
                        props.user.user.first_name !==
                        props.user.whoIsThis.first_name ||
                        props.user.user.last_name !==
                        props.user.whoIsThis.last_name ||
                        props.user.user.phone !== props.user.whoIsThis.phone
                    ) {
                        let payload = {
                            first_name: props.user.whoIsThis.first_name,
                            last_name: props.user.whoIsThis.last_name,
                            phone: props.user.whoIsThis.phone,
                        };
                        props.orderUser(payload);
                      }
                    }
                    setTimeout(() => {
                      onOrderSubmit(payloadCardDetails, null);
                    }, 500);
                  }
                } else {
                //   props.setState({ loading: false });
                setLoading(false);
                setButtonDisable(false);
                setBlocked(false);
                //   toast.error(Constants.VALID_CVC);
                //   addToast({
                //     alertStatus: Constants.TOAST_TYPE_WARNING,
                //     alertTitle: Constants.TOAST_HEADING_WARNING,
                //     alertDescription:Constants.VALID_CVC,
                // });
                setErrorMessage({error: true, message: Constants.VALID_CVC});
                setTimeout(() => {
                    setErrorMessage({});
                }, 5000);
                }
              } else {
                // props.setState({ loading: false });
                // toast.error(Constants.VALID_EXPIRY_DATE);
                setLoading(false);
                setButtonDisable(false);
                setBlocked(false);
                // addToast({
                //     alertStatus: Constants.TOAST_TYPE_WARNING,
                //     alertTitle: Constants.TOAST_HEADING_WARNING,
                //     alertDescription:Constants.VALID_EXPIRY_DATE,
                // });
                setErrorMessage({error: true, message: Constants.VALID_EXPIRY_DATE});
                setTimeout(() => {
                    setErrorMessage({});
                }, 5000);
              }
            } else {
            //   this.setState({ loading: false });
                setLoading(false);
                setButtonDisable(false);
                setBlocked(false);
            //   toast.error(Constants.VALID_CARD_NUMBER);
            // addToast({
            //     alertStatus: Constants.TOAST_TYPE_WARNING,
            //     alertTitle: Constants.TOAST_HEADING_WARNING,
            //     alertDescription:Constants.VALID_CARD_NUMBER,
            // });
            setErrorMessage({error: true, message: Constants.VALID_CARD_NUMBER});
            setTimeout(() => {
                setErrorMessage({});
            }, 5000);
            }
            }
            else{
                setLoading(false);
                setButtonDisable(false);
                setBlocked(false);
                let card_details = null;
                let existing_card_details = null;

                if (
                    undefined !== store.getState().card_details &&
                    null !== store.getState().card_details &&
                    showCardForm &&
                    store.getState().card_details &&
                    0 !== store.getState().card_details 
                ) {
                    card_details = store.getState().card_details;
                    existing_card_details = null;
                } else {
                    card_details = null;
                    existing_card_details = selectedCard;
                }
                if (
                    isValidObject(props.user.whoIsThis)
                ) {
                if (
                    props.user.user.first_name !==
                    props.user.whoIsThis.first_name ||
                    props.user.user.last_name !==
                    props.user.whoIsThis.last_name ||
                    props.user.user.phone !== props.user.whoIsThis.phone
                ) {
                    let payload = {
                        first_name: props.user.whoIsThis.first_name,
                        last_name: props.user.whoIsThis.last_name,
                        phone: props.user.whoIsThis.phone,
                    };
                        props.orderUser(payload);
                    }
                }
                setTimeout(() => {
                    onOrderSubmit(card_details, existing_card_details);
                }, 500);
            }
          } else {
            setLoading(false);
            setButtonDisable(false);
            setBlocked(false);
            handleSignInRequired();
        }
    };
    const renderCardDetails = () => (
        <VStack spacing={4} align="stretch">

            {/* <Box>
                <Text mb={2}>Card Number *</Text>
                <Input
                    name="cardNumber"
                    value={state.cardNumber}
                    onChange={handleCardInputChange}
                    onFocus={handleInputFocus}
                    placeholder="4242 4242 4242 4242"
                    size="lg"
                    borderRadius="md"
                    isInvalid={cardErrors.cardNumber !== ''}
                />
                {cardErrors.cardNumber && (
                    <Text color="red.500" fontSize="sm">{cardErrors.cardNumber}</Text>
                )}
            </Box>

            <HStack spacing={4}>
                <Box flex={1}>
                    <Text mb={2}>Valid Thru *</Text>
                    <Input
                        name="expiry"
                        value={state.expiry}
                        onChange={handleCardInputChange}
                        onFocus={handleInputFocus}
                        placeholder="MM/YY"
                        size="lg"
                        borderRadius="md"
                        isInvalid={cardErrors.expiry !== ''}
                    />
                    {cardErrors.expiry && (
                        <Text color="red.500" fontSize="sm">{cardErrors.expiry}</Text>
                    )}
                </Box>
                <Box flex={1}>
                    <Text mb={2}>CVC *</Text>
                    <Input
                        name="cvc"
                        value={state.cvc}
                        onChange={handleCardInputChange}
                        onFocus={handleInputFocus}
                        placeholder="123"
                        type="tel"
                        size="lg"
                        borderRadius="md"
                        isInvalid={cardErrors.cvc !== ''}
                    />
                    {cardErrors.cvc && (
                        <Text color="red.500" fontSize="sm">{cardErrors.cvc}</Text>
                    )}
                </Box>
            </HStack> */}
            {showCardForm ? (
                <>
                <Box>
                {/* <Input
                    name="cardNumber"
                    value={formikCardDetails.values.cardNumber}
                    onChange={handleCardFormat}
                    onBlur={formikCardDetails.handleBlur}
                    // onFocus={handleInputFocus}
                    placeholder="4242 4242 4242 4242"
                    size="lg"
                    borderRadius="md"
                    isInvalid={formikCardDetails.touched.cardNumber && formikCardDetails.errors.cardNumber}
                /> */}  
                    <Box width="100%" maxW="400px" mx="auto" mb={4}>
                        <Cards
                            number={formikCardDetails.values.cardNumber}
                            name=""
                            expiry={formikCardDetails.values.expiry}
                            cvc={formikCardDetails.values.cvc}
                            focused={state.focused}
                        />
                    </Box>
                <HomeText isLabelText={true} name="Card Number" mb={2} />
                <GrubInput
                    id="cardNumber"
                    posInput={true}
                    onFocus={() => setState({ focused: 'cardNumber' })}
                    placeholder="Enter card number"
                    inputValue={formikCardDetails.values.cardNumber}
                    handleInputChange={handleCardFormat}
                    handleBlur={(e) => {
                        formikCardDetails.handleBlur(e);
                        setState({ focused: '' });
                    }}
                    inputError={formikCardDetails.touched.cardNumber && formikCardDetails.errors.cardNumber}
                />
                {formikCardDetails.touched.cardNumber && formikCardDetails.errors.cardNumber && (
                    <Text color="red.500" fontSize="sm">{formikCardDetails.errors.cardNumber}</Text>
                )}
            </Box>

            <HStack spacing={4}>
                <Box flex={1}>
                    <HomeText isLabelText={true} name="Valid Thru" mb={2} />
                    <GrubInput
                        id="expiry"
                        posInput={true}
                        placeholder="MM/YY"
                        onFocus={() => setState({ focused: 'expiry' })}
                        inputValue={formikCardDetails.values.expiry}
                        handleInputChange={handleCardFormat}
                        handleBlur={(e) => {
                            formikCardDetails.handleBlur(e);
                            setState({ focused: '' });
                        }}
                        inputError={formikCardDetails.touched.expiry && formikCardDetails.errors.expiry}
                    />
                    {/* {formikCardDetails.touched.expiry && formikCardDetails.errors.expiry && (
                        <Text color="red.500" fontSize="sm">{formikCardDetails.errors.expiry}</Text>
                    )} */}
                    <Text 
                        color="red.500" 
                        fontSize="sm" 
                        visibility={formikCardDetails.touched.expiry && formikCardDetails.errors.expiry ? "visible" : "hidden"}
                        height="1.5rem" // Fixed height for consistency
                    >
                        {formikCardDetails.errors.expiry || "placeholder"}
                    </Text>
                </Box>
                <Box flex={1}>
                    <HomeText isLabelText={true} name="CVC *" mb={2} />
                    <GrubInput
                        id="cvc"
                        posInput={true}
                        placeholder="***"
                        onFocus={() => setState({ focused: 'cvc' })}
                        inputValue={formikCardDetails.values.cvc}
                        handleInputChange={handleCardFormat}
                        handleBlur={(e) => {
                            formikCardDetails.handleBlur(e);
                            setState({ focused: '' });
                        }}
                        inputError={formikCardDetails.touched.cvc && formikCardDetails.errors.cvc}
                    />
                    {/* {formikCardDetails.touched.cvc && formikCardDetails.errors.cvc && (
                        <Text color="red.500" fontSize="sm">{formikCardDetails.errors.cvc}</Text>
                    )} */}
                    <Text 
                        color="red.500" 
                        fontSize="sm" 
                        visibility={formikCardDetails.touched.cvc && formikCardDetails.errors.cvc ? "visible" : "hidden"}
                        height="1.5rem" // Fixed height for consistency
                    >
                        {formikCardDetails.errors.cvc || "placeholder"}
                    </Text>
                </Box>
            </HStack>
            {showCardForm && (
                <>
                {(props?.delivery_pickup[0]?.location?.id || props.locationId) && (
                    <>
                    <Flex
                        h={"2.81rem"}
                        bg={
                            Colors.grubSaveDetailsBackGroundColor
                        }
                        borderRadius="7px"
                        border="1px"
                        alignItems="center"
                        justifyContent="left"
                        borderColor={
                            Colors.grubPaymentMethodIconBorderColor
                        }
                        gap={2}
                    >
                    <Checkbox
                        isChecked={saveCard}
                        onChange={(e) =>
                            setSaveCard(
                                e.target.checked
                            )
                        }
                        color={Colors.taxInfo}
                        _checked={{
                            "& .chakra-checkbox__control":
                                {
                                    bg: "#5881FE",
                                    borderColor:
                                        "#5881FE",
                                },
                        }}
                        ml={4}
                    />
                    <Text
                        color={
                            Colors.grubDescriptionColor
                        }
                        size={"sm"}
                    >
                        Save information for
                        next time{" "}
                    </Text>
                    </Flex>
                    <Flex
                        h={"2.81rem"}
                        bg={
                            Colors.grubSaveDetailsBackGroundColor
                        }
                        borderRadius="7px"
                        border="1px"
                        alignItems="center"
                        justifyContent="left"
                        borderColor={
                            Colors.grubPaymentMethodIconBorderColor
                        }
                        gap={2}
                        mb={2}
                    >
                        <Checkbox
                            isChecked={
                                showCardForm &&
                                isDefaultCard
                            }
                            onChange={(e) => {
                                setIsDefaultCard(
                                    e.target.checked
                                );
                                if (e.target.checked) {
                                    setSelectedDefaultCardId(
                                        null
                                    );
                                }
                            }}
                            color={Colors.taxInfo}
                            _checked={{
                                "& .chakra-checkbox__control":
                                    {
                                        bg: "#5881FE",
                                        borderColor:
                                            "#5881FE",
                                    },
                            }}
                            ml={4}
                        />
                        <Text
                            color={
                                Colors.grubDescriptionColor
                            }
                            size={"sm"}
                        >
                            Set as Default Card
                            </Text>
                    </Flex>
                    </>
                )}
                    {showCardForm && props.user?.user?.user_card_details?.length > 0 && (props?.delivery_pickup[0]?.location?.id || props.locationId) && (
                        <Button
                            w={"100%"}
                            variant="outline"
                            onClick={() => {
                                setShowCardForm(false);
                                setIsDefaultCard(false);
                            }}
                        >
                            Use Saved Card
                        </Button>
                    )}
                </>
            )}
            </>
            ) : (
                <>
                    {props.user?.user?.user_card_details
                        ?.length > 0 && (props?.delivery_pickup[0]?.location?.id || props.locationId) ? (
                        <VStack
                            spacing={4}
                            align="stretch"
                        >
                            <GrubTitleText
                                isOrderSummaryText={
                                    true
                                }
                                name={"Pay Via"}
                                fontWeight={500}
                                color={
                                    Colors.posTextInfo
                                }
                            />
                            {/* Add this Box wrapper around your cards mapping */}
                            <Box 
                                maxH="350px" 
                                overflowY="auto"
                                mb={props.user?.user?.user_card_details?.length > 4 ? 4 : 0}
                                css={{
                                    '&::-webkit-scrollbar': {
                                        width: '4px',
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        background: '#f1f1f1',
                                        borderRadius: '4px',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: '#888',
                                        borderRadius: '4px',
                                    },
                                    '&::-webkit-scrollbar-thumb:hover': {
                                        background: '#555',
                                    },
                                }}
                            >
                                {props.user?.user?.user_card_details
                                    ?.sort((a, b) => {
                                        if (a.is_card_default === true) return -1;
                                        if (b.is_card_default === true) return 1;
                                        return 0;
                                    })
                                    .map((card, index) => (
                                        <Flex
                                            key={card.id}
                                            direction="column"
                                            p={2}
                                            border="1px"
                                            borderColor={Colors.grubPaymentMethodIconBorderColor}
                                            borderRadius="7px"
                                            mb={2} // Add margin bottom between cards
                                        >
                                            <Flex
                                                key={card.id}
                                                justifyContent="space-between"
                                                alignItems="center"
                                            >
                                                <Flex
                                                    gap={3}
                                                    alignItems="center"
                                                >
                                                    <BoxForPaymentMethode
                                                        icon={
                                                            card.brand ===
                                                            "Visa"
                                                                ? VisaLogo
                                                                : card.brand ===
                                                                    "MasterCard"
                                                                ? MasterCard
                                                                : card.brand ===
                                                                    "Discover"
                                                                ? DiscoverLogo
                                                                : card.brand ===
                                                                    "AmericanExpress"
                                                                ? AmericanEx
                                                                : card.brand ===
                                                                    "DinersClub"
                                                                ? DinersClub
                                                                : card.brand ===
                                                                    "JCB"
                                                                ? JCBLogo
                                                                : card.brand ===
                                                                    "UnionPay"
                                                                ? UnionPayLogo
                                                                : defaultIcon
                                                        }
                                                    />
                                                    <Flex
                                                        direction="row"
                                                        gap={2}
                                                    >
                                                        <Flex
                                                        gap={{
                                                            base: 0,
                                                            sm: 4,
                                                        }}
                                                        alignItems="center"
                                                        direction={{
                                                            base: "column",
                                                            sm: "row",
                                                        }}
                                                        justifyContent="center"
                                                        >
                                                            <Text
                                                                color={
                                                                    Colors.posTextInfo
                                                                }
                                                                fontWeight="500"
                                                            >
                                                                ****
                                                                ****
                                                                ****{" "}
                                                                {
                                                                    card.card_ending
                                                                }
                                                            </Text>
                                                            <Text
                                                           color={
                                                            Colors.grubDescriptionColor
                                                        }
                                                        whiteSpace="nowrap"
                                                        display="inline-flex"
                                                        alignItems="center"
                                                        >
                                                            Expires{" "}
                                                            {
                                                                card.card_exp_month
                                                            }

                                                            /
                                                            {
                                                                card.card_exp_year
                                                            }
                                                        </Text>
                                                        </Flex>
                                                        <Flex
                                                                                direction={{
                                                                                    base: "column",
                                                                                    sm: "row",
                                                                                }}
                                                                                justifyContent="center"
                                                                            >
                                                        {card.is_card_default ===
                                                            true && (
                                                            <Text
                                                                fontSize="xs"
                                                                color="green.500"
                                                                bg="green.50"
                                                                px={2}
                                                                py={0.5}
                                                                borderRadius="full"
                                                            >
                                                                Default
                                                            </Text>
                                                        )}
                                                        </Flex>
                                                    </Flex>
                                                </Flex>
                                                <Flex
                                                   gap={{
                                                    base: 6,
                                                    sm: 8,
                                                }}
                                                >
                                                    {!card.is_card_default && (
                                                        <DeleteIcon
                                                        ml={2}
                                                            color={
                                                                "red"
                                                            }
                                                        cursor="pointer"
                                                        sx={{
                                                            transition:
                                                                "opacity 0.3s ease-in-out",
                                                            "&:hover":
                                                                {
                                                                    opacity: 0.7,
                                                                },
                                                        }}
                                                        onClick={() => {
                                                            if (card.is_card_default) {
                                                                addToast({
                                                                    alertStatus: Constants.TOAST_TYPE_WARNING,
                                                                    alertTitle: Constants.TOAST_HEADING_WARNING,
                                                                    alertDescription: Constants.CANNOT_DELETE_DEFAULT_CARD,
                                                                });
                                                                return;
                                                            }
                                                            setIsOpenModal(
                                                                true
                                                            );
                                                            setDeleteSelectedCard(
                                                                card
                                                            );
                                                        }}
                                                    />
                                                    )}
                                                    <Radio
                                                        isChecked={
                                                            selectedCardId ===
                                                            card.id
                                                        }
                                                        onChange={() => {
                                                            setSelectedCardId(
                                                                card.id
                                                            );
                                                            setSelectedCard(
                                                                card
                                                            );
                                                            setIsDefaultCard(
                                                                false
                                                            );
                                                            setSelectedDefaultCardId(
                                                                null
                                                            );
                                                        }}
                                                        colorScheme="blue"
                                                    />
                                                </Flex>
                                            </Flex>
                                            {!card.is_card_default && selectedCardId === card.id && (
                                                <Flex
                                                    alignItems="center"
                                                    justifyContent="left"
                                                    gap={2}
                                                    mt={2}
                                                >
                                                    <Checkbox
                                                        isChecked={
                                                            selectedDefaultCardId ===
                                                            card.id
                                                        }
                                                        // isDisabled={
                                                        //     selectedCardId !==
                                                        //     card.id
                                                        // }
                                                        onChange={(
                                                            e
                                                        ) => {
                                                            if (
                                                                e
                                                                    .target
                                                                    .checked
                                                            ) {
                                                                setSelectedDefaultCardId(
                                                                    card.id
                                                                );
                                                                setIsDefaultCard(
                                                                    true
                                                                );
                                                            } else {
                                                                setSelectedDefaultCardId(
                                                                    null
                                                                );
                                                                setIsDefaultCard(
                                                                    false
                                                                );
                                                            }
                                                        }}
                                                        color={
                                                            Colors.taxInfo
                                                        }
                                                        _checked={{
                                                            "& .chakra-checkbox__control":
                                                                {
                                                                    bg: "#5881FE",
                                                                    borderColor:
                                                                        "#5881FE",
                                                                },
                                                        }}
                                                    />
                                                    <Text
                                                        color={
                                                            Colors.grubDescriptionColor
                                                        }
                                                        size={
                                                            "sm"
                                                        }
                                                    >
                                                        Set
                                                        as
                                                        Default
                                                        Card
                                                    </Text>
                                                </Flex>
                                            )}
                                        </Flex>
                                    ))}
                            </Box>
                            
                            {/* Keep the "Add New Card" button outside the scrollable area */}
                            <Button
                                variant="outline"
                                onClick={() => {
                                    setShowCardForm(true);
                                    setIsDefaultCard(false);
                                    setSelectedDefaultCardId(null);
                                }}
                                leftIcon={<AddIcon />}
                            >
                                Add New Card
                            </Button>
                        </VStack>
                    ) : (
                        <>
                            {/* <Text>
                                There are no saved cards
                                found
                            </Text> */}
                            <Button
                                w={"100%"}
                                variant="outline"
                                onClick={() => {
                                    setShowCardForm(true);
                                    setIsDefaultCard(false);
                                    setSelectedDefaultCardId(null);
                                }}
                                leftIcon={<AddIcon />}
                            >
                                Add Card
                            </Button>
                        </>
                    )}
                </>
            )}

            {/* Action Buttons */}
            {errorMessage && errorMessage.error && errorMessage.message && (
                <GrubErrorMessage
                    errorMessage={errorMessage.message}
                    width={"auto"}
                />
            )}
            <HStack spacing={4} mt={2} mb={4}>
                <GrubFormButton
                    buttonsubmit="BACK"
                    width="50%"
                    bg={Colors.posTextInfo}
                    onClick={() => handleBackClick(2)}
                    isDisabled={loading}
                />
                <GrubFormButton
                    buttonsubmit={
                        window.innerWidth <= 480 
                            ? `PAY $${getFormattedAmount()}`  // Shorter text for mobile
                            : `PAY ($${getFormattedAmount()})`  // Full text for desktop
                    }
                    width="50%"
                    bg={Colors.posTextInfo}
                    style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        fontSize: window.innerWidth <= 480 ? '14px' : '16px',  // Smaller font for mobile
                        padding: window.innerWidth <= 480 ? '8px' : '16px'     // Less padding for mobile
                    }}
                    isDisabled={
                        // showCardForm ? !formikCardDetails.values.cardNumber 
                        // || !formikCardDetails.values.expiry 
                        // || !formikCardDetails.values.cvc 
                        // || formikCardDetails.errors.cardNumber 
                        // || formikCardDetails.errors.expiry 
                        // || formikCardDetails.errors.cvc 
                        // || 
                        loading
                        || buttonDisable
                        // : 
                        // !selectedCardId
                        // || 
                        // loading 
                        // || buttonDisable
                    }
                    onClick={() => {
                        if(showCardForm && (!formikCardDetails.values.cardNumber 
                            || !formikCardDetails.values.expiry 
                            || !formikCardDetails.values.cvc 
                            || formikCardDetails.errors.cardNumber 
                            || formikCardDetails.errors.expiry 
                            || formikCardDetails.errors.cvc)) {
                            formikCardDetails.setTouched({
                                cardNumber: true,
                                expiry: true,
                                cvc: true
                            });
                            return;
                        }
                        else if(!showCardForm && !selectedCardId){
                            return;
                        }
                        else{
                            makePayment()
                        }
                    }}
                />
            </HStack>
        </VStack>
    );

    const deleteCard = (card) => {
        setLoading(true);
        setButtonDisable(true);
        try {
            deleteUserCardDetail(card)
                .then((response) => {
                    if (
                        undefined !== response.data.flag &&
                        null !== response.data.flag &&
                        response.data.flag == true
                    ) {
                        addToast({
                            alertStatus:
                                Constants.TOAST_TYPE_SUCESS,
                            alertTitle:
                                Constants.TOAST_HEADING_SUCCESS,
                            alertDescription:
                                response.data.data.message,
                        });
                        setLoading(false);
                        setButtonDisable(false);
                        props.userLogin(response.data.data.user);
                        setIsOpenModal(false);      
                    } else {
                        let actionData = response.data;
                        // error({ actionData });
                        let popupError = error({ actionData });
                        if (popupError.error) {
                            setErrorMessage(popupError);
                            setTimeout(() => {
                                setErrorMessage({});
                            }, 5000);
                        }
                        setLoading(false);
                        setButtonDisable(false);
                        setIsOpenModal(false);
                    }
                })
                .catch((err) => {
                    let actionData = err;
                    // error({ actionData });
                    let popupError = error({ actionData });
                    if (popupError.error) {
                        setErrorMessage(popupError);
                        setTimeout(() => {
                            setErrorMessage({});
                        }, 5000);
                    }
                    setLoading(false);
                    setButtonDisable(false);
                    setIsOpenModal(false);
                });
        } catch (error) {
            let actionData = error;
            // error({ actionData });
            let popupError = error({ actionData });
            if (popupError.error) {
                setErrorMessage(popupError);
                setTimeout(() => {
                    setErrorMessage({});
                }, 5000);
            }
            setLoading(false);
            setButtonDisable(false);
            setIsOpenModal(false);
        }
    };

    // Add a function to reset all states to initial values
    const resetAllStates = () => {
        setCurrentStep(1);
        setCustomAmount('');
        setSelectedAmount(null);
        setRecipientEmail('');
        setRecipientPhone('');
        setCustomMessage('');
        setGiftCardCode('');
        setMaskedGiftCardCode('');
        setErrors({
            number: '',
            email: '',
            sms: '',
            message: '',
        });
        setButtonDisable(false);
        setSignInModalOpen(false);
        // setCardNumber('');
        // setValidThru('');
        // setCvc('');
        // setCardType('default');
        // setFocused('');
        setCardErrors({
            cardNumber: '',
            expiry: '',
            cvc: ''
        });
        setState({
            expanded: false,
            number: "",
            selectButtonAmount: 0.0,
            name: "",
            expiry: "",
            cvc: "",
            issuer: "",
            focused: "",
            formData: null,
            cardNumber: "",
            backgroundImage: "",
            errors: {
                number: "",
                email: "",
                sms: "",
                message: "",
            },
            cardErrors: {
                cardNumber: "",
                expiry: "",
                cvc: "",
            },
            firstLayout: true,
            secondLayout: false,
            generateGiftNumber: 0,
            email: "",
            sms: "",
            message: "",
        });
        formikGiftCard.resetForm();
        formikCardDetails.resetForm();
    };

    // Add this new function near your other handlers
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && !loading && !buttonDisable) {
            event.preventDefault();
            
            // Step 1: Amount Selection
            if (currentStep === 1) {
                if (selectedAmount || (customAmount && !errors.number)) {
                    const { fullNumber, maskedNumber } = generateGiftCardNumber();
                    setGiftCardCode(fullNumber);
                    setMaskedGiftCardCode(maskedNumber);
                    setCurrentStep(2);
                }
            }
            // Step 2: Gift Card Details
            else if (currentStep === 2) {
                if (!buttonDisable && 
                    (formikGiftCard.values.email || formikGiftCard.values.phone) && 
                    !Object.keys(formikGiftCard.errors).length) {
                    formikGiftCard.handleSubmit();
                }
            }
            // Step 3: Card Details
            else if (currentStep === 3) {
                if (showCardForm) {
                    if (!buttonDisable && 
                        formikCardDetails.values.cardNumber && 
                        formikCardDetails.values.expiry && 
                        formikCardDetails.values.cvc && 
                        !Object.keys(formikCardDetails.errors).length) {
                        makePayment();
                    }
                } else {
                    if (!buttonDisable && selectedCardId) {
                        makePayment();
                    }
                }
            }
        }
    };

    return (
        <>
            <Modal 
                isOpen={props.isOpen} 
                onClose={loading ? undefined : handleCloseModal}
                size={{ base: "xl", md: "xl" }}
                closeOnOverlayClick={false}
                closeOnEsc={false}
                autoFocus={false}
                returnFocusOnClose={false}
                zIndex="modal"
            >
                <ModalOverlay />
                <ModalContent 
                    marginLeft="1rem" 
                    marginRight="1rem" 
                    borderRadius="md" 
                    // pb={4}
                    onKeyDown={handleKeyDown}
                    position="relative"
                >
                    <Box position="relative">
                        <BlockUI
                            blocked={blocked}
                            template={
                                <ProgressSpinner
                                    style={{
                                        width: "100px",
                                        height: "100px",
                                    }}
                                    pt={{
                                        svg: {
                                            style: {
                                                animation: "none",
                                            },
                                        },
                                        circle: {
                                            style: {
                                                stroke: "#5881FE",
                                                strokeWidth: "4px",
                                                animation:
                                                    "p-progress-spinner-dash 1.5s ease-in-out infinite",
                                            },
                                        },
                                    }}
                                />
                            }
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                zIndex: 1000,
                                borderRadius: 'inherit',
                            }}
                        >
                            {loading && (
                                <GrubProgress />
                            )}
                            <ModalHeader fontSize="2xl">
                                <HomeText
                                    isLabelText={true} 
                                    fontWeight={500} 
                                    name={currentStep === 1 ? 'Buy Gift Card' : 
                                    currentStep === 2 ? 'Gift Card Details' : 'Card Details'} 
                                />
                            </ModalHeader>
                            <ModalCloseButton 
                                onClick={handleCloseModal}
                                isDisabled={loading}
                                style={{ display: loading ? 'none' : 'block' }}
                            />
                            <ModalBody>
                                {currentStep === 1 ? renderAmountSelection() :
                                currentStep === 2 ? renderGiftCardDetails() :
                                renderCardDetails()}
                            </ModalBody>
                        </BlockUI>
                    </Box>
                </ModalContent>
            </Modal>
            <GrubDialogAlert
                leastDestructiveRef={cancelRef}
                onClose={handleCloseDeleteCard}
                isOpen={isOpenes}
                title={"Remove Card"}
                discription={"Are you sure you want to romove this card?"}
                onClick={() => deleteCard(deleteSelectedCard)}
                buttonNames={["Cancel", "Romove"]}
            />
            
            {/* {showAuthLayout && ( */}
                <AuthLayout
                    isOpen={isSignInModalOpen}
                    onClose={handleCloseSignInModal}
                    // trapFocus={true}
                    // blockScrollOnMount={true}
                    zIndex="popover"
                />
            {/* )} */}
        </>
    );
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            currentItem,
            removeCurrentItem,
            orderCalculation,
            insertItem,
            updateOrdertype,
            orderInstruction,
            addExtraItem,
            removeUserCardDetails,
            userLogout,
            userLogin,
            clearItems,
            addUserCardDetails,
            addPaymentCardId,
            orderUser,
            removeLocations,
            removeDeliveryPickupDetails,
            removeFeaturedProducts,
            removeProducts,
            removeOrderUser,
            completeOrder,
        },
        dispatch
    );
}

function mapStateToProps(state) {
    return {
        current_item: state.current_item,
        locations: state.locations,
        delivery_pickup: state.delivery_pickup,
        order: state.order,
        order_items: state.order_items,
        user: state.user,
        card_details: state.card_details,
    };
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
  )(GiftCardModal);